import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup, Label } from 'reactstrap';

import { dataContractApi } from '../../../../helpers/api/dataContractApi';
import { MountTypeText } from '../../../../helpers/enums/mountTypeEnum';
import RequiredStarLabel from '../../../common/requiredStarLabel';
import EntitySelect from '../../../entitySelect/EntitySelect';
import FormGroupNote from '../../FormGroupNote';

export default function MountTypeSelect({ isRequired = false, isDisabled }) {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <FormGroup>
      <Label htmlFor="mountType">
        {t('Mount Type')} {isRequired && <RequiredStarLabel />}
      </Label>
      <Controller
        name="mountType"
        control={control}
        render={({ field }) => (
          <EntitySelect
            name="mountType"
            displayName={t('Mount Type')}
            fieldValue={field.value}
            onChange={field.onChange}
            placeholder="Not specified"
            fetchDataFunction={() => {
              return dataContractApi.getDataContractsByContractType(
                'switchboard-mount-types'
              );
            }}
            isFetchDataEnum
            enumToText={MountTypeText}
            isDisabled={isDisabled}
          />
        )}
      />
      {errors.mountType && (
        <FormGroupNote type={'warning'}>
          {errors.mountType.message}
        </FormGroupNote>
      )}
    </FormGroup>
  );
}
